import styled from 'styled-components'

// import colors from '@settings/styleSettings'

export const Container = styled.div`
  height: 100%;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
`
